import { createContext } from "react";

export interface MaintenanceMessage {}

export interface MaintenanceMessageInterface {
  isMaintenance: boolean | undefined;
  isImpending: boolean | undefined;
  impendingMessage?: string;
  maintenanceMessage?: string;
  impendingMaintenanceStartTimestamp: string,
  maintenanceStartTimestamp: string,
  maintenanceEndTimestamp: string
}

const initialContext = {
  isMaintenance: undefined,
  isImpending: undefined,
  impendingMessage: '',
  maintenanceMessage: '',
  impendingMaintenanceStartTimestamp: '',
  maintenanceStartTimestamp: '',
  maintenanceEndTimestamp: ''
};

export const MaintenanceMessageContext = createContext<MaintenanceMessageInterface>(initialContext);
